import React, { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PageHeader from '@node-space/storybook-components/dist/PageHeader'
import { Box, Button, Icon, Input, Text } from '@node-space/ui-components'
import { AddCustomer } from './AddCustomer/AddCustomer'
import { CustomersView } from './components/CustomersView'

export const EmbeddedCustomers = () => {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState('')
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const onAddNewCustomer = () => {
    setIsSheetOpen(true)
  }

  const onCloseAddNewCustomer = () => {
    setIsSheetOpen(false)
  }

  return (
    <>
      <PageHeader
        description={<Text color="subdued">{t('embeddedCustomers.description')}</Text>}
        renderRightSection={
          <Button
            onClick={onAddNewCustomer}
            name={t('customers.addNewCustomer')}
            iconElement={<Icon name="Plus" />}
          >
            {t('customers.addNewCustomer')}
          </Button>
        }
      />
      <Box flexCol gap={16}>
        <Input
          placeholderText={t('embeddedCustomers.searchPlaceholder')}
          value={searchQuery}
          onChange={(event: ChangeEvent<HTMLInputElement>) => setSearchQuery(event?.target?.value)}
          searchable
          testId="embedded-customers-search-field"
        />
        <CustomersView searchQuery={searchQuery} resetSearchQuery={() => setSearchQuery('')} />
      </Box>
      <AddCustomer isOpen={isSheetOpen} onClose={onCloseAddNewCustomer} />
    </>
  )
}
